import { pagesConfig } from '../../../shared/pages-config';
import ApiGrid from './api-grid';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function ApiPage() {
  const { administrationRoles, changeLogRoles } = useUserSettings();

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.administration.name },
        { label: pagesConfig.api.name },
      ]}
      bookmarkKey={pagesConfig.api.value}
    >
      <ApiGrid
        administrationRoles={administrationRoles}
        changeLogRoles={changeLogRoles}
      />
    </SimpleBreadcrumbsPage>
  );
}
